import { useDependencies } from '../dependencies';

export const Page404 = (): JSX.Element => {
  const {
    services: { tracker },
  } = useDependencies();

  tracker.track('hit 404');

  return (
    <main>
      <div className='container py-12'>
        <h1>This page is missing!</h1>
        <a className='font-semibold' href='/app/dashboard'>Go to dashboard &raquo;</a>
      </div>
    </main>
  );
};
